import { render, staticRenderFns } from "./ParsianTransaction.vue?vue&type=template&id=01757f95&scoped=true&"
import script from "./ParsianTransaction.vue?vue&type=script&lang=js&"
export * from "./ParsianTransaction.vue?vue&type=script&lang=js&"
import style0 from "./ParsianTransaction.vue?vue&type=style&index=0&id=01757f95&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01757f95",
  null
  
)

export default component.exports